<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import Swal from "sweetalert2";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CheckModal from "@/components/CheckModal";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import Table from "@/components/standard/PromotionPrevention/components/PromotionTable";
import { dateFormat } from "@/utils/helpers/format";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import auditoriaAPI from "../../../services/standards/auditoria/auditoriaAPI";
import AuditoriasEvidencePagination from "../../../components/standard/auditorias/AuditoriasEvidencePagination.vue";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "6.1.2 Auditoria anual del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
    AuditoriasEvidencePagination,
  },
  data() {
    return {
      title: "6.1.2 Auditoria anual del SG SST",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "6.1.2 Auditoria anual del SG SST",
          active: true,
        },
      ],
      list: [],
      usersList: [],

      item: null,

      itemData: null,
      search: "",
      form_submitting: false,

      lista: [],
      loading: true,

      file: null,
      file2: null,
      deleteCount: 0,
      auditoria: {
        plan: null,
        report: null,
        business_audits_id: this.$route.params.id,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      lastId: 1
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(54)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    deletePlan(id) {
      auditoriaAPI.deleteP(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 54,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 54)
          .then((response) => {
            this.item = response || null;
          })
          .catch((error) => {
            this.item = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        console.log(error);
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/6.1.2/plan-auditoria-documento/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/6.1.2/plan-auditoria-documento/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.auditoria.plan = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async uploadDocument2() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/6.1.2/informe-inspeccion-documento/${this.lastId}/${this.file2.name}`;
        } else {
          url = `sst-prod/${this.nit}/6.1.2/informe-inspeccion-documento/${this.lastId}/${this.file2.name}`;
        }
        const result = await uploadDocument(url, this.file2);
        if (result) {
          this.auditoria.report = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesPromocion(response.id).then((res) => {
            this.usersList = res.employee;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      auditoriaAPI.getAllA(this.$store.getters["company/getCompany"].id || null, this.$route.params.id)
        .then((response) => {
          this.lista = response.data.data
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async save() {
      this.form_submitting = true;
      this.loading = true
      // Verificar que al menos uno de los documentos esté cargado
      if (!this.file && !this.file2) {
        this.form_submitting = false;
        this.loading = false
        Swal.fire({
          title: "¡Error!",
          text: "¡Debe cargar al menos un documento antes de guardar!",
          type: "warning",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        return;
      }
      try {
        // Subir el primer documento si existe
        if (this.file) {
          const uploadResult1 = await this.uploadDocument();
          if (!uploadResult1) {
            this.form_submitting = false;
            this.loading = false
            Swal.fire({
              title: "¡Error",
              text: "¡Error al cargar el plan de auditoría.",
              type: "error",
              icon: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }
        }

        // Subir el segundo documento si existe
        if (this.file2) {
          const uploadResult2 = await this.uploadDocument2();
          if (!uploadResult2) {
            this.form_submitting = false;
            this.loading = false
            Swal.fire({
              title: "¡Error!",
              text: "¡Error al cargar el informe de auditoría!",
              type: "error",
              icon: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            return;
          }
        }

        // Guardar la auditoría
        const response = await auditoriaAPI.saveA(this.auditoria).then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 54,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              setTimeout(() => {
                this.form_submitting = false;
                this.loading = false
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Se ha registrado con éxito!",
                  icon: "success",
                  type: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1500);
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1500);
              console.log(error);
            });
        }).catch((error) => {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "Error",
              text: "¡No se ha podido registrar!",
              icon: "error",
              type: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload();
          }, 1500);
          console.log(error);
        });;
      } catch (error) {
        console.log(error);
        this.form_submitting = false;
        this.loading = false
        Swal.fire({
          title: "¡Error!",
          text: "¡Error al guardar la auditoría!",
          type: "error",
          icon: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      }
    },
  },
  mounted() {
    this.getList();
    this.getItems();
    this.getItemData();
    this.getUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading">
          <div class="card">
            <div class="card-body">

              <div class="row px-3">
                <div class="col-6">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa deberá realizar por lo menos una vez al año, para
                      verificar el cumplimiento del Decreto 1072 de 2015, la
                      resolución 0312 de 2019 y demás requisitos normativos del SG
                      SST.
                    </p>
                    <p class="text-justify">
                      En este ítem la empresa podrá realizar el programa de
                      auditorías, donde indicará cada una de las auditorias que se
                      realizarán en el año y posteriormente podrá encontrar las
                      herramientas para realizar el plan e informe de cada
                      auditoria, la cual será planificada con la participación del
                      Comité Paritario de Seguridad y Salud en el Trabajo o Vigía.
                    </p>
                    <p class="text-justify">
                      En la base de conocimiento encontrará un procedimiento guía
                      para la realización de las auditorias.
                    </p>
                  </CheckModal>
                </div>
                <div class="col-6 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>

              <form class="form-group px-2" @submit.prevent="save">
                <hr />
                <h5 class="px-2">Realizar programa de auditorias</h5>
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6 px-2" label="Cargar plan de auditoría" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile">
                    </b-form-file>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Cargar informe de auditoría" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file2" ref="file2"
                      name="file2" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      drop-placeholder="Suelta acá..." v-model="file2" @change="uploadFile" v-on:change="uploadFile">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 pt-2">
                  <button type="submit" :disabled="!allowAccess() ||
                    !getRole('Crear') ||
                    this.form_submitting === true
                    " class="btn btn-primary mx-1">
                    Guardar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle"> Fecha subido el archivo </th>

                              <th class="text-center align-middle">
                                Plan de auditoría
                              </th>
                              <th class="text-center align-middle">
                                Informe de auditoría
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.create_evidence) }}
                              </td>
                              <td class="text-center align-middle">
                                <div v-if="dato.plan === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.plan}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.report === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.report}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>

                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">
                                          Advertencia
                                        </h4>
                                        <p class="mt-3">
                                          Al modificar esta información se
                                          quitará el puntaje correspondiente a
                                          este ítem y será necesario realizar
                                          nuevamente la validación por parte del
                                          usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()
                                          " type="button" class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white" :to="{
                                            path: `/forms/estandares/auditoria-plan-editar/${dato.id}`,
                                          }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="
                                          $bvModal.hide(`modal${dato.id}`)
                                          " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                          Cancelar
                                        </button>
                                      </div>
                                    </b-modal>
                                    <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                      " :to="{
                                        path: `/forms/estandares/auditoria-plan-ver/${dato.id}`,
                                      }">
                                      Ver
                                    </b-dropdown-item>

                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deletePlan(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <AuditoriasEvidencePagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>